import endpoint from '../endpoint/endpoint'

export default {
  install(Vue) {
    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$endpoint = endpoint
  },
}
